import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortOption } from './ride-filter.model';
import { RideFilter } from './ride-filter.model';

@Component({
  selector: 'app-ride-filter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ride-filter.component.html',
  styleUrl: './ride-filter.component.css'
})
export class RideFilterComponent implements OnInit, OnChanges {
 
  @Input() maxDistance = 100; // km, dolazi iz roditelja
  @Output() filterChange = new EventEmitter<RideFilter>();
 
  // ── Sort state ──
  activeSort: SortOption = 'newest';
 
  sortOptions: { value: SortOption; label: string; icon: string }[] = [
    { value: 'newest',         label: 'Najnovije',              icon: '🕐' },
    { value: 'oldest',         label: 'Najstarije',             icon: '📅' },
    { value: 'distance-desc',  label: 'Najveća udaljenost',     icon: '↑📏' },
    { value: 'distance-asc',   label: 'Najmanja udaljenost',    icon: '↓📏' },
    { value: 'max-speed-desc', label: 'Najveća brzina',         icon: '⚡' },
    { value: 'avg-speed-desc', label: 'Prosječna brzina',       icon: '📊' },
    { value: 'duration-desc',  label: 'Najdulja vožnja',        icon: '⏱️' },
  ];
 
  // ── Filter state ──
  filtersOpen = false;
  dateFrom: string | null = null;
  dateTo: string | null = null;
  distanceMin = 0;
  distanceMax = 100;
  todayStr = new Date().toISOString().split('T')[0];
  activeQuickDate: 'today' | 'week' | 'month' | 'year' | null = null;
 
  get activeFilterCount(): number {
    let count = 0;
    if (this.dateFrom || this.dateTo) count++;
    if (this.distanceMin > 0 || this.distanceMax < this.maxDistance) count++;
    return count;
  }
 
  ngOnInit(): void {
    this.distanceMax = this.maxDistance;
  }
 
  ngOnChanges(): void {
    // Ako se maxDistance promijeni (nakon što se dohvate vožnje),
    // resetiraj max slider samo ako korisnik nije ručno postavio vrijednost
    if (this.distanceMax === 100 || this.distanceMax > this.maxDistance) {
      this.distanceMax = this.maxDistance;
    }
  }
 
  // ── Sort ──
  setSort(value: SortOption): void {
    this.activeSort = value;
    this.emit();
  }
 
  // ── Filter toggle ──
  toggleFilters(): void {
    this.filtersOpen = !this.filtersOpen;
  }
 
  // ── Datum ──
  onDateFromChange(event: Event): void {
    this.dateFrom = (event.target as HTMLInputElement).value || null;
    this.activeQuickDate = null; // ručna promjena = poništi quick-date highlight
    this.emit();
  }
 
  onDateToChange(event: Event): void {
    this.dateTo = (event.target as HTMLInputElement).value || null;
    this.activeQuickDate = null; // ručna promjena = poništi quick-date highlight
    this.emit();
  }
 
  clearDates(): void {
    this.dateFrom = null;
    this.dateTo = null;
    this.activeQuickDate = null;
    this.emit();
  }
 
  setQuickDate(period: 'today' | 'week' | 'month' | 'year'): void {
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
 
    this.dateTo = fmt(now);
 
    if (period === 'today') {
      this.dateFrom = fmt(now);
    } else if (period === 'week') {
      const d = new Date(now);
      d.setDate(d.getDate() - 6);
      this.dateFrom = fmt(d);
    } else if (period === 'month') {
      this.dateFrom = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-01`;
    } else if (period === 'year') {
      this.dateFrom = `${now.getFullYear()}-01-01`;
    }
 
    this.activeQuickDate = period; // postavi aktivni quick-date
    this.emit();
  }
 
  // ── Slider ──
  onMinSlider(event: Event): void {
    const val = +(event.target as HTMLInputElement).value;
    if (val >= this.distanceMax) {
      this.distanceMin = this.distanceMax - 1;
      (event.target as HTMLInputElement).value = String(this.distanceMin);
    } else {
      this.distanceMin = val;
    }
    this.emit();
  }
 
  onMaxSlider(event: Event): void {
    const val = +(event.target as HTMLInputElement).value;
    if (val <= this.distanceMin) {
      this.distanceMax = this.distanceMin + 1;
      (event.target as HTMLInputElement).value = String(this.distanceMax);
    } else {
      this.distanceMax = val;
    }
    this.emit();
  }
 
  // ── Clear all ──
  clearFilters(): void {
    this.dateFrom = null;
    this.dateTo = null;
    this.distanceMin = 0;
    this.distanceMax = this.maxDistance;
    this.activeQuickDate = null;
    this.emit();
  }
 
  // ── Emit ──
  private emit(): void {
    this.filterChange.emit({
      sort: this.activeSort,
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
      distanceMin: this.distanceMin,
      distanceMax: this.distanceMax,
    });
  }
}